// extracted by mini-css-extract-plugin
module.exports = {"title":"suggested-posts-module--title--1gwIp"};